export default __webpack_public_path__ + "755f18a1e9716d638e6f0b991078a700.png";